module.exports = __webpack_public_path__ + "media/images/prop-img-1024-bb2e88397fba46be834fe7476470b838.svg";